<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="dialog" width="400px">
      <v-card width="400px">
        <v-layout wrap pa-5>
          <v-flex xs12 text-center pb-5 style="font-family: nunitosansbold">
            Are you sure you want to delete this Notice?
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-end text-right>
              <v-flex align-self-center xs6 sm2
                ><v-btn text color="blue darken-1" @click="remove(A)">
                  yes</v-btn
                ></v-flex
              >
              <v-flex align-self-center xs6 sm2
                ><v-btn text color="blue darken-1" @click="dialog = false">
                  No</v-btn
                ></v-flex
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout justify-center wrap>
      <v-flex xs6 sm4 md1 pl-md-3>
        <v-img width="30px" src="./../../assets/images/notice.svg"></v-img>
      </v-flex>
      <v-flex xs12 sm8 md8 lg8 align-self-center>
        <span style="font-family: nunitosansbold; font-size: 18px"
          >Noticeboard</span
        >
      </v-flex>
      <v-flex xs12 sm4 md3 lg3>
        <b>
          <router-link
            style="text-decoration: none"
            :to="{ path: '/noticeadd' }"
          >
            <v-btn
              :width="
                $vuetify.breakpoint.name !== 'md' &&
                $vuetify.breakpoint.name !== 'sm'
                  ? '275'
                  : '100%'
              "
              outlined
              style="
                text-transform: none;
                font-size: 12px;
                font-family: nunitosansbold;
              "
              color="grey"
            >
              <span style="color: black"> Create new Notice </span>
            </v-btn>
          </router-link></b
        >
      </v-flex>
      <v-flex xs12 pt-5>
        <v-layout justify-start wrap v-for="(item, i) in notice" :key="i" py-4>
          <v-flex xs12 sm12 md5 pr-0 pr-sm-5>
            <v-card @click="viewPage(item._id)">
              <v-img
                class="white--text align-center"
                height="250px"
                :src="mediaURL + item.image"
              >
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 pt-4 pa-3>
                    <v-icon color="white">mdi-image-outline</v-icon>
                  </v-flex>
                  <v-flex xs12 sm12 md12 pb-6 pa-3>
                    <span
                      style="font-family: nunitosansextrabold; font-size: 22px"
                      >{{ item.title }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-img>
            </v-card>
          </v-flex>
          <v-flex xs12 sm12 md7>
            <span
              style="
                font-family: nunitosanssemibold;
                font-size: 20px;
                color: #000000;
              "
              >{{ item.title }} </span
            ><br />

            <v-flex xs12 pt-3>
              <span style="color: #777676; font-family: nunitosansregular">
                {{ item.description }}
              </span>
            </v-flex>
            <v-flex xs12 pt-4>
              <span style="color: #717171; font-family: nunitosansregular">{{
                item.author
              }}</span>
            </v-flex>
            <v-layout justify-center wrap>
              <v-flex xs4>
                <span
                  style="
                    color: #717171;
                    font-family: nunitosansregular;
                    font-size: 12px;
                  "
                  >{{ item.designation }}</span
                >
              </v-flex>
              <v-flex xs4>
                <span
                  style="
                    color: #717171;
                    font-family: nunitosansregular;
                    font-size: 12px;
                  "
                  >{{ DateFormatted(item.noticeDate) }}</span
                >
              </v-flex>
              <v-flex xs2 text-right>
                <v-icon color="#645D5D" @click="edit(item._id)"
                  >mdi-clipboard-edit</v-icon
                >
              </v-flex>
              <v-flex xs2 text-right>
                <v-icon color="#645D5D" @click="(dialog = true), (A = item._id)"
                  >mdi-delete-outline</v-icon
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="text-center pb-5" v-if="pages>1">
      <v-pagination
        :length="pages"
        :total-visible="7"
        v-model="currentPage"
        color="#9B8DFD"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      A: null,
      page: 1,
      currentPage: 1,
      pages: 0,
      count: 4,
      totalData: 0,
      dialog: false,
      showsnackbar: false,
      timeout: 5000,
      notice: [],
      appLoading: false,
      msg: "",
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y ,hh:mm A") : "";
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      }).then((response) => {
        if (response.data.status) {
          this.notice = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
          this.appLoading = false;
        } else {
          console.log("failed");
        }
      });
    },
    viewPage(value) {
      this.$router.push({
        path: "/noticeview",
        query: {
          key: value,
        },
      });
    },
    edit(item) {
      this.$router.push({
        path: "/noticeEdit",
        query: {
          key: item,
        },
      });
    },
    remove(item) {
      axios({
        method: "post",
        url: "/notice/remove",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      }).then((response) => {
        if (response.data.status) {
          console.log("success");
          this.showsnackbar = true;
          this.msg = "Successfully removed";
          this.$router.go();
        } else {
          this.showsnackbar = true;
          this.msg = "failed";
        }
      });
    },
  },
};
</script>